import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = {
  class: "scene-slides-wrp w-100",
  ref: "slidesWrp"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("i", { class: "pi pi-chevron-left control-handler" }, null, -1)
const _hoisted_3 = { class: "room-object room-object--start" }
const _hoisted_4 = { class: "fs-18" }
const _hoisted_5 = { class: "room-object__head" }
const _hoisted_6 = { class: "room-object__icon bt-icon bt-icon--s text-primary" }
const _hoisted_7 = {
  key: 0,
  class: "fs-18 text-truncate"
}
const _hoisted_8 = {
  key: 0,
  class: "fs-14"
}
const _hoisted_9 = /*#__PURE__*/_createVNode("i", { class: "pi pi-chevron-right control-handler" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InlineSvgScoped = _resolveComponent("InlineSvgScoped")
  const _component_SceneTimeObject = _resolveComponent("SceneTimeObject")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (!_ctx.isFirstStep && _ctx.showHandlers)
      ? (_openBlock(), _createBlock("div", {
          key: 0,
          class: "scene-slides-wrp__control-arrow lx-arrow",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.prevSlide && _ctx.prevSlide(...args)))
        }, [
          _hoisted_2
        ]))
      : _createCommentVNode("", true),
    _createVNode("div", _hoisted_3, [
      _createVNode("h5", _hoisted_4, _toDisplayString(_ctx.slideTitle), 1)
    ]),
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.items, (a) => {
      return (_openBlock(), _createBlock("div", {
        key: `${_ctx.slideType}-${a.id}`,
        class: "room-object"
      }, [
        _createVNode("div", _hoisted_5, [
          _createVNode("span", _hoisted_6, [
            (!!a.icon)
              ? (_openBlock(), _createBlock(_component_InlineSvgScoped, {
                  key: 0,
                  src: 
                            require(`@/assets/images/icons/` + a.icon + '.svg')
                        
                }, null, 8, ["src"]))
              : _createCommentVNode("", true)
          ]),
          (a?.sceneObjectType !== _ctx.timeBasedObjectDescriptor)
            ? (_openBlock(), _createBlock("span", _hoisted_7, _toDisplayString(a.objectName), 1))
            : (_openBlock(), _createBlock(_component_SceneTimeObject, {
                key: 1,
                "time-object": a
              }, null, 8, ["time-object"]))
        ]),
        (a?.sceneObjectType !== _ctx.timeBasedObjectDescriptor)
          ? (_openBlock(), _createBlock("span", _hoisted_8, _toDisplayString(_ctx.SceneUtils.getObjectDescription(a, _ctx.sceneId, _ctx.plant)), 1))
          : _createCommentVNode("", true)
      ]))
    }), 128)),
    (!_ctx.isLastStep && _ctx.showHandlers)
      ? (_openBlock(), _createBlock("div", {
          key: 1,
          class: "scene-slides-wrp__control-arrow rx-arrow",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.nextSlide && _ctx.nextSlide(...args)))
        }, [
          _hoisted_9
        ]))
      : _createCommentVNode("", true)
  ], 512))
}